import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardIssueUnsubmittedWork from "src/components/card/SfxCardIssueUnsubmittedWork.vue"
import router from "src/router"
import { TAB_TO_DO_UNSUBMITTED_WORK } from "src/util/constants/navigation"
import { NamedPath } from "src/util/enums/namedPaths"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { PayloadEntity } from "src/util/types/dataModels/genericObject"
import { Issue } from "src/util/types/dataModels/issue"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListUnsubmittedWorkIssues',
  props: {
  entityId: {
    type: String,
    required: true,
  },

  issueList: {
    type: Array as PropType<PayloadEntity<Issue>[]>,
    required: true,
  },

  workOrderId: {
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const { dialogRef } = useDialogPluginComponent()

const countTotalIssues = computed(() => props.issueList?.length)

const title = t("sfxDialogListIssue.title_unsubmitted_work_issues")

// TODO: When procedures are implemented, count the total number of required issues and change the text accordingly
const textRaisedIssues = t("sfxDialogListIssue.text_raised_issues", {
  count: countTotalIssues.value,
})

const textHowToProceed = t("sfxDialogListIssue.text_proceed")
const labelReviewWork = t("sfxButtons.btn_review_work")
const labelRaiseIssue = t("sfxButtons.btn_raise_next_issue")

//endregion

//region Functions

async function reviewWork() {
  await router.replace({
    name: NamedPath.TO_DO,
    params: { unsubmittedWorkId: TAB_TO_DO_UNSUBMITTED_WORK },
  })

  if (props.workOrderId) {
    await router.push({
      name: NamedPath.PLANNED_REGULAR_WORK,
      params: { itemId: props.entityId, workOrderId: props.workOrderId },
    })
  } else {
    await router.push({
      name: NamedPath.ADHOC_REGULAR_WORK,
      params: { itemId: props.entityId },
    })
  }
}

async function raiseNextIssue() {
  // TODO: Fix
  showNotImplementedNotification()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-list" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(textRaisedIssues) }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(textHowToProceed)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "sfx-dialog-list-elements" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.issueList, (issue, index) => {
                return (_openBlock(), _createBlock(SfxCardIssueUnsubmittedWork, {
                  key: index,
                  issue: issue,
                  workOrderId: __props.workOrderId,
                  onClick: _unref(showNotImplementedNotification)
                }, null, 8, ["issue", "workOrderId", "onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(labelReviewWork),
                class: "col",
                onClick: reviewWork
              }, null, 8, ["label"]),
              _createVNode(SfxBtn, {
                label: _unref(labelRaiseIssue),
                class: "col",
                onClick: raiseNextIssue
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})